export default "__VITE_ASSET__BXgVda3___"